import { render } from "./orderTerms.vue?vue&type=template&id=4957012f&scoped=true&ts=true"
import script from "./orderTerms.vue?vue&type=script&lang=ts"
export * from "./orderTerms.vue?vue&type=script&lang=ts"

import "./orderTerms.vue?vue&type=style&index=0&id=4957012f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4957012f"]])

export default __exports__